'use client';

import React from 'react';
import Script from 'next/script';

// 1. Extend the Window interface to include the bKash bridge
declare global {
  interface Window {
    webViewJSBridge?: {
      goBackHome: (merchantName: string) => void;
    };
  }
}

interface BkashBackButtonProps {
  merchantName: string; // Pass your merchant name here
  isProduction?: boolean; // Toggle between Staging (false) and Production (true)
}

const FOOTER_HEIGHT = 50;

const BkashBackButton: React.FC<BkashBackButtonProps> = ({
  merchantName,
  isProduction = false,
}) => {
  // 2. define URLs based on environment
  const scriptSrc = isProduction
    ? 'https://cdn.capp.bka.sh/scripts/webview_bridge.js'
    : 'https://capp-cdn.labs.bka.sh/scripts/webview_bridge.js';

  const imageSrc = isProduction
    ? 'https://cdn.capp.bka.sh/images/arrow.svg'
    : 'https://capp-cdn.labs.bka.sh/images/arrow.svg';

  // 3. Handle the click
  const handleBackHome = () => {
    if (typeof window !== 'undefined' && window.webViewJSBridge) {
      window.webViewJSBridge.goBackHome(merchantName);
    } else {
      console.warn(
        'bKash Web View Bridge is not loaded yet or running outside the app.'
      );
    }
  };

  return (
    <>
      {/* Load external bKash script */}
      <Script src={scriptSrc} strategy="lazyOnload" />

      <div style={{ height: `${FOOTER_HEIGHT}px` }} />

      <button
        id="bkash_btn"
        type="button"
        onClick={handleBackHome}
        style={{
          position: 'fixed',
          left: 0,
          bottom: 0,
          width: '100%',
          height: '50px',
          fontSize: '18px',
          marginTop: '2%',
          color: 'white',
          textAlign: 'left',
          backgroundColor: '#E2136E',
          borderColor: '#E2136E',
          border: 'none', // Reset default border
          borderRadius: '0px',
          cursor: 'pointer',
          zIndex: 9999, // Ensure it is on top
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between', 
          padding: '0 15px', // Added padding so text isn't stuck to the edge
        }}
      >
        <span>Back to bKash App Home</span>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={imageSrc}
          alt="arrow"
          style={{
            height: '20px',
            marginTop: '0%',
          }}
        />
      </button>
    </>
  );
};

export default BkashBackButton;
